import React, { useMemo } from "react";
import ItineraryMetadata from "./ItineraryMetadata";
import { useTranslate } from "../../translate";
import { getDaysCount } from "./utils";
import { useFixHTML } from "./hooks";

function getImagesFromData(data) {
    if (!data) {
        return [];
    }
    const { itineraryData, routeData } = data;
    let images;
    if (itineraryData.metadata.imageGallery && itineraryData.metadata.imageGallery?.[0]?.image2x) {
        images = itineraryData.metadata.imageGallery;
    } else {
        images = [routeData.defaultPosterImage];
    }
    return images.map(image => image.image2x || image.medium2x);
}

function ItineraryMetadataContainer(props) {
    const { data, formattedStops, ...restProps } = props;
    const translate = useTranslate();
    const itineraryImages = useMemo(() => {
        return getImagesFromData(data);
    }, [data]);
    const routeLogo = data?.routeData?.routeLogo;
    const itineraryImg = itineraryImages?.[0];
    const routeName = data?.routeData?.routeName;
    const itineraryName = translate(data?.itineraryData?.metadata, "name");
    const itineraryType = data?.itineraryData?.metadata?.type?.name;
    const days = useMemo(() => getDaysCount(data?.itineraryData), [data]);
    const distance = useMemo(() => {
        return formattedStops
            .filter(stop => stop.type === "stop")
            .reduce((length, stop) => length + stop.distToNext, 0)
            .toFixed(0);
    }, [formattedStops]);
    const stopsCount = useMemo(() => {
        if (!data) {
            return 0;
        }
        return data.itineraryData.stops.filter(stop => stop.type === "stop").length;
    }, [data]);
    const itineraryDescription = translate(data?.itineraryData?.metadata, "description");
    const newItineraryDescription = useFixHTML(itineraryDescription);
    const hasMidwayPoint = data?.routeData?.routeType?.toUpperCase() === "TRAIL";
    const hasPlace = data?.itineraryData?.stops?.find(stop => stop.type === "place_start");
    const hasCustomizationsEnabled = data?.itineraryData?.metadata?.customizations?.toUpperCase() !== "INACTIVE";
    const hideStartingPointField =
        data?.routeData?.routeType?.toUpperCase() !== "LOOP" || hasPlace || !hasCustomizationsEnabled;
    const showLoopDirections = !hasMidwayPoint && hasCustomizationsEnabled;
    return (
        <ItineraryMetadata
            routeLogo={routeLogo}
            itineraryImg={itineraryImg}
            routeName={routeName}
            itineraryName={itineraryName}
            itineraryType={itineraryType}
            days={days}
            distance={distance}
            stopsCount={stopsCount}
            itineraryDescription={newItineraryDescription}
            showLoopDirections={showLoopDirections}
            hideStartingPointField={hideStartingPointField}
            {...restProps}
        />
    );
}

export default ItineraryMetadataContainer;
